import { useState } from "react";
import { addressLines } from "@/mocks/home";

const statusClass: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-foreground-950",
};

export default function AddressSection() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section id="address" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-links-line"></i>
              官网入口
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              最新地址与官网入口
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              地址会随线路维护与网络环境变化而更新。下表展示当前各线路的可用状态，
              请优先使用标记为「推荐」的入口。若某条线路打开缓慢，切换其余线路即可。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
            {addressLines.map((line) => (
              <div
                key={line.name}
                className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 flex flex-col"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
                      <i className="ri-global-line text-xl"></i>
                    </span>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{line.name}</h3>
                  </div>
                  <span
                    className={`px-2.5 py-1 rounded-full text-xs font-medium ${statusClass[line.statusType]}`}
                  >
                    {line.status}
                  </span>
                </div>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed flex-1">{line.desc}</p>
                <div className="mt-5 flex items-center gap-2 pt-4 border-t border-background-200/60">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs text-foreground-500">状态：可访问 · 建议收藏本页以获取更新</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 rounded-lg bg-secondary-50 border border-secondary-200/70 p-5 md:p-6">
            <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
              <span className="w-12 h-12 shrink-0 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-file-copy-2-line text-2xl"></i>
              </span>
              <div className="flex-1">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  一键收藏本页地址
                </h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                  点击右侧按钮即可复制本页链接，粘贴到收藏夹、云笔记或聊天窗口。
                  有了多重备份，即使原地址失效也能随时找回。
                </p>
              </div>
              <button
                type="button"
                onClick={handleCopy}
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
                {copied ? "已复制本页链接" : "复制本页链接"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}